import React, { useEffect, useState } from "react";
import breadcrumbImage from "../../../assets/images/course/cousre.jpg";
import mainImg from "../../../assets/images/Home/main-img.png";
import {
  Container,
  Modal,
  Form,
  Button,
  Card,
  CardBody,
} from "react-bootstrap";
import Pagination from "../../components/Pagination";
import DOMPurify from "dompurify";
import axios from "axios";
import swal from "sweetalert";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Header from "../../include/header";

const Viewdetails = ({ handleclick }) => {
  const [Booklist, setBooklist] = useState([]);

  const [imagePath, setImagePath] = useState("");
  const [lentght, setlentght] = useState("");
  const [fooder, setfooder] = useState("");
  const [trigger, setTrigger] = useState(false);
  // ✅ Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;
  const totalPages = Math.ceil(Booklist.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const booksAll = Booklist.slice(startIndex, startIndex + itemsPerPage);
  const user_id = localStorage.getItem("user_id");
  const [bgImage, setBgImage] = useState("");
  // ✅ Address Modal State
  const [showModal, setShowModal] = useState(false);
  const [selectedBook, setSelectedBook] = useState(null);
  const [address, setAddress] = useState({
    address_line1: "",
    address_line2: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
  });

  useEffect(() => {
    fetchBookList();
    footerdata();
    bannerimg();
  }, []);

  // ✅ Fetch Book List
  const id = localStorage.getItem("bookId");

  const fetchBookList = async () => {
    try {
      const id = localStorage.getItem("bookId");

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/book-view`,
        { id: id } // 👈 body में भेज रहे हैं
      );

      // setBooklist(response.data?.data || []);

      setBooklist(
        Array.isArray(response.data?.data)
          ? response.data.data
          : [response.data?.data]
      );

      setImagePath(response.data?.imagePath || "");
      setlentght(response.data?.total);
    } catch (error) {
      console.error("Book list fetch error:", error);
    }
  };

  // ✅ Footer Data
  const footerdata = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/site-setting`
      );
      setfooder(res.data.data);
    } catch (error) {}
  };

  useEffect(() => {
    bookcount();
  }, []);

  // ✅ Add to Cart

  const bookcount = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/book-cart-count`,
        { user_id: user_id }
      );

      const count = res.data.cartCount || 0;
      localStorage.setItem("cartCount", count);

      // ✅ Header update trigger
      window.dispatchEvent(new Event("cartUpdated"));
    } catch (err) {
      console.error(err);
    }
  };

  const handleAddToCart = async (book) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/book-cart`,
        {
          user_id: user_id, // static user_id
          book_id: book.id,
          quantity: 1,
        }
      );

      if (res.data.success === "1") {
        toast.success("Book added to cart!"); // ✅ Success toaster
        bookcount();
      } else {
        toast.error(res.data.message || "Failed to add book!"); // ✅ Error toaster
      }
    } catch (err) {
      console.error(err);
      setTrigger((prev) => !prev); // ✅ Error toaster
    }
  };

  // ✅ Open Buy Now Modal
  const handleBuyNow = (book) => {
    setSelectedBook(book);
    setShowModal(true);
  };

  // ✅ Place Order
  const handlePlaceOrder = async () => {
    try {
      if (!selectedBook) return;

      const orderPayload = {
        user_id: user_id,
        total_amount: selectedBook.manual_price || selectedBook.price,
        status: "pending",
        ...address,
        items: [
          {
            book_id: selectedBook.id,
            quantity: 1,
            price: selectedBook.manual_price || selectedBook.price,
          },
        ],
      };

      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/book-order`,
        orderPayload
      );

      if (res.data.success === "1") {
        swal("Success", "Order placed successfully!", "success");
        setShowModal(false);
        setAddress({
          address_line1: "",
          address_line2: "",
          city: "",
          state: "",
          pincode: "",
          country: "",
        });
      } else {
        swal("Error", res.data.message, "error");
      }
    } catch (err) {
      console.error(err);
      swal("Error", "Something went wrong!", "error");
    }
  };

  // ✅ Trimmed Description
  const getTrimmedHTML = (html, wordLimit = 50) => {
    const textOnly = html.replace(/<[^>]+>/g, "");
    const words = textOnly.split(/\s+/).slice(0, wordLimit);
    const trimmedText = words.join(" ") + "...";
    const cleanHTML = DOMPurify.sanitize(trimmedText);
    return { __html: cleanHTML };
  };

  const navigate = useNavigate();

  const Viewdetails = (book) => {
    // localStorage में id सेव कर दो
    localStorage.setItem("bookId", book.id);

    // navigate करो Viewdetails page पर
    navigate("/viewdetails");
  };

  const bannerimg = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/home-seeting-list`
      );

      const baseUrl = res.data.imagePath;
      const courseImage = res.data.home_setting[0]?.course_image;

      // Full image URL
      const fullUrl = baseUrl + courseImage;

      setBgImage(fullUrl);
    } catch (error) {
      console.error("Error fetching banner:", error);
    }
  };

  return (
    <section className="course books">
      <Header handleclick={trigger} />
      <div className="page_header"></div>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="rs-breadcrumbs breadcrumbs-overlay">
        <div className="breadcrumbs-img">
          <img src={bgImage} alt="Breadcrumbs bg" />
        </div>
        <div className="breadcrumbs-text white-color">
          <h1 className="page-title">Books</h1>
        </div>
      </div>

      {fooder.blogpermission == 1 ? (
        <Container>
          <div className="row py-60">
            {booksAll.map((book, index) => (
              <>
                <div className="col-lg-4 col-md-4" key={index}>
                  <div className="bookimage">
                    <img
                      src={book?.image ? `${imagePath}${book.image}` : mainImg}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = mainImg;
                      }}
                      alt={book?.title || "Book Image"}
                    />
                    {/* <p className="date">{book.date}</p> */}
                  </div>
                </div>
                <div className="col-md-8 col-lg-8 col-12">
                  <Card>
                    <CardBody>
                      <h5 className="mb-8">{book.title}</h5>
                      <div
                        className="mb-24"
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            book.description
                              .split(" ")
                              .slice(0, 200)
                              .join(" ") + "..."
                          ),
                        }}
                      ></div>

                       {/*<div className="d-flex justify-content-between align-items-center">
                        {(() => {
                          const mrp = Math.max(book.price, book.manual_price); // बड़ा value = MRP
                          const discountPrice = Math.min(
                            book.price,
                            book.manual_price
                          );
                          const discountPercent = Math.round(
                            ((mrp - discountPrice) / mrp) * 100
                          );

                          return (
                            <h6 className="pricecontent mb-0">
                              <span className="price">₹{discountPrice}</span>
                              <span className="text-muted text-decoration-line-through ms-2">
                                ₹{mrp}
                              </span>
                              {discountPercent > 0 && (
                                <span className="text-success ms-2">
                                  {discountPercent}% off
                                </span>
                              )}
                            </h6>
                          );
                        })()}
                      </div>*/}

                      {/* ✅ Buttons */}
                      <div className="d-flex gap-2 mt-2">
                        {/* <button
                          className="educate-btn"
                          onClick={() => handleAddToCart(book)}
                        >
                          <span className="educate-btn__curve"></span>
                          Add to Cart
                        </button> */}
                        {/* <button
                                                className="btn btn-success"
                                                onClick={() => handleBuyNow(book)}
                                            >
                                                Buy Now
                                            </button> */}
                        {/* <button
                                                className="btn btn-success"
                                                onClick={() => Viewdetails(book)}
                                            >
                                                Viewdetails
                                            </button> */}
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </>
            ))}

            {totalPages >= 6 && (
              <Pagination
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages}
              />
            )}
          </div>
        </Container>
      ) : (
        ""
      )}

      {/* ✅ Address Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Enter Address</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Address Line 1</Form.Label>
              <Form.Control
                type="text"
                value={address.address_line1}
                onChange={(e) =>
                  setAddress({ ...address, address_line1: e.target.value })
                }
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Address Line 2</Form.Label>
              <Form.Control
                type="text"
                value={address.address_line2}
                onChange={(e) =>
                  setAddress({ ...address, address_line2: e.target.value })
                }
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>City</Form.Label>
              <Form.Control
                type="text"
                value={address.city}
                onChange={(e) =>
                  setAddress({ ...address, city: e.target.value })
                }
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>State</Form.Label>
              <Form.Control
                type="text"
                value={address.state}
                onChange={(e) =>
                  setAddress({ ...address, state: e.target.value })
                }
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Pincode</Form.Label>
              <Form.Control
                type="text"
                value={address.pincode}
                onChange={(e) =>
                  setAddress({ ...address, pincode: e.target.value })
                }
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Country</Form.Label>
              <Form.Control
                type="text"
                value={address.country}
                onChange={(e) =>
                  setAddress({ ...address, country: e.target.value })
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={handlePlaceOrder}>
            Place Order
          </Button>
        </Modal.Footer>
      </Modal>
    </section>
  );
};

export default Viewdetails;
